export const workflowsEndpoints = {
  getWorkflow: { method: 'get', path: '/{workflowId}' },
  listWorkflows: { method: 'get', path: '/' },
  createWorkflow: { method: 'post', path: '/' },
  duplicateWorkflow: { method: 'post', path: '/{workflowId}/duplicate' },
  updateWorkflowMetadata: { method: 'post', path: '/{workflowId}/metadata' },
  updateWorkflowRanks: { method: 'post', path: '/ranks' },
  listConditionGroups: { method: 'get', path: '/{workflowId}/condition-groups' },
  createConditionGroup: { method: 'post', path: '/{workflowId}/condition-groups' },
  updateConditionGroup: { method: 'post', path: '/{workflowId}/condition-groups/{conditionGroupId}/update' },
  deleteConditionGroup: { method: 'post', path: '/{workflowId}/condition-groups/{conditionGroupId}/delete' },
} as const
